import { render, staticRenderFns } from "./Activity5_2QandA.vue?vue&type=template&id=9a200006&"
import script from "./Activity5_2QandA.vue?vue&type=script&lang=js&"
export * from "./Activity5_2QandA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports